import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { JobService } from "../../Network/services/JobService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { commonService } from "../../Network/services/commonService";
import Modal from "react-modal";
import GoogleMapReact from "google-map-react";
import "./MyJobsDetailView.css";
import TermFinishedIcon from "../../assets/images/TermFinsihedIcon.svg";
import FilePreview from "../FilePreview";
import ProfilePopup from "../ProfilePopup";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});


const MarkerComponent = ({ text }) => (
  <div style={{ 
  position: 'absolute',
  transform: 'translate(-50%, -100%)',
  zIndex: 1000
}}>
  <div style={{
    width: 30,
    height: 30,
    backgroundColor: '#F57E1F',
    border: '3px solid white',
    borderRadius: '50% 50% 50% 0',
    transform: 'rotate(-45deg)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{
      transform: 'rotate(45deg)',
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold',
      width: '8px',
      height: '8px',
      backgroundColor: 'white',
      borderRadius: '50%'
    }}>
      
    </div>
  </div>
</div>
);

const MyJobsDetailView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [ord_id, setOrd_id] = useState("");
  const [mapView, setMapView] = useState(false);
  const [jobData, setJobData] = useState(null);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);

  var newWindow = null;
  var countdown;

  useEffect(() => {
    if (location.state?.item?.id) {
      fetchUpdatedJobData(location.state.item.id, true);
    } else {
      history.goBack();
    }
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const handleProfileIconClick = (userData) => {
    setSelectedUserData(userData);
    setShowProfilePopup(true);
  }

  const closeProfilePopup = () => {
    setShowProfilePopup(false);
    setSelectedUserData(null);
  }

  const INTERVAL_DELAY = 1000;

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const fetchUpdatedJobData = async (jobId, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }
      const response = await JobService.getJobById(jobId);
      if (response.status === "200" && response.data && response.data.length > 0) {
        setJobData(response.data[0]);
        return response.data[0];
      } else {
        toast.error(response.message || "Failed to fetch updated job data", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        if (isInitialLoad) {
          history.goBack();
        }
      }
    } catch (error) {
      console.error("Error fetching updated job data:", error);
      toast.error("Something went wrong while fetching job data. Please try again.", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      if (isInitialLoad) {
        history.goBack();
      }
    } finally {
      if (isInitialLoad) {
        setInitialLoading(false);
      } else {
        setLoading(false);
      }
    }
    return null;
  };

  const updateStatus = (id, milestone, status, milestone_id ) => {

    
    setLoading(true);
    const form = new FormData();
    form.append("milestone", milestone);
    form.append("milestone_status", status);
    form.append("job_id", id);
    if(milestone_id != null) {
      form.append("milestone_id", milestone_id);
      form.append("employee_status", status);
      form.append("quote_id", jobData?.awarded_to_quote_id);
    }
    commonService
      .CommonService("employee_mark_as_completed", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          await fetchUpdatedJobData(id);
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (initialLoading) {
    return (
      <section className="explore explore1">
        <div className="container">
          <div className="banner">
            <div className="row">
              <div className="col-md-4">
                <div className="breadcrumps">
                  <ul>
                    <li>
                      <div onClick={back}>
                        <a href="#">
                          <i className="bx bx-chevron-left" /> Back to My Jobs 
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="explore-details">
            <div className="row">
              <div className="col-md-12 text-center">
                <LoadingOverlay>
                  <Loader loading={true} />
                </LoadingOverlay>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!jobData) {
    history.goBack();
    return null;
  }

  return (
    <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-6">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to My Jobs 
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="explore-details">
          <div className="row">
            <div className="col-md-7">
              <p className="jobid">
                Job#{" "}
                <span>
                  {jobData?.job_unique_id?.substr(
                    jobData?.job_unique_id?.indexOf(" ") + 1
                  )}
                </span>
              </p>
              
              <h1 className="title">{jobData?.job_title}</h1>
              
              <ul className="list-two">
                <li>
                  <a href="#!">
                    {jobData?.job_location} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {jobData?.bid_payment_term} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!" >
                  Posted {jobData?.timestamp} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    Awarded on {jobData?.awarded_date}
                  </a>
                </li>
              </ul>
              
              <p className="job-details-label quote-detail-job-label-no-margin">Project Budget</p>
              <div className="payment-amount">
                ₹{jobData?.amount}
              </div>
              <p className="job-details-label">Category</p>
              <div className="job-category">
                {jobData?.parent_category_name && jobData?.category_full_name
                  ? `${jobData.parent_category_name} > ${jobData.category_full_name}`
                  : jobData?.category_full_name || jobData?.category || 'General'}
                </div>            
                  {jobData?.latitude && jobData?.longitude && (
                    <span>
                    <p className="job-details-label" style={{ marginBottom: '0px' }}>Location</p>
                      <a 
                        href="#!"
                        onClick={(e) => { e.preventDefault(); setMapView(true); }}
                        style={{ textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }}
                      >
                        View On Map
                      </a>
                    </span>
                  )}
              {jobData?.skills && (
                <>
                  <p className="job-details-label">Required Skills</p>
                  <ul className="category-list">
                    {jobData.skills.split(',').map((skill, index) => (
                      <li key={index} className="skill-tag">
                        {skill.trim()}
                      </li>
                    ))}
                  </ul>
                </>
              )}
              
              <p className="job-details-label quote-detail-job-label-no-margin">About Job</p>
              <p>{jobData?.job_description}</p>
              {jobData?.attach_file && jobData.attach_file.length > 0 && (
                <>
                  <p className="job-details-label">Attachments</p>
                  <div className="form-group myresume-file-preview-container">
                    {jobData.attach_file.split(",").map((file, index) => (
                      <FilePreview 
                        key={index}
                        fileUrl={file}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5">
              <section className="profile you-quoted share status">

                <LoadingOverlay>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6 padding-0">
                        <h3>Job Status</h3>
                      </div>
                      
                      {/* <div className="col-md-6 padding-0">
                        <a href="#" className="message">
                          <img src="/assets/images/message.png" /> Message
                        </a>
                      </div> */}
                    </div>
                    <div className="profile-detail yorself awarded">
                      <div className="row">
                        <div className="col-md-12 padding-0">
                          <a href={`/user-detail/${jobData?.employer_details?.id}`} className="profile-avatar">

                            {jobData?.employer_details?.profile_image && jobData?.employer_details?.profile_image !== "" ? (
                              <img src={`${jobData?.employer_details?.profile_image.includes("https://") ? jobData?.employer_details?.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/${jobData?.employer_details?.profile_image}`}`} />
                            ) : (
                              <img src="/assets/images/profile-avatar.png" />
                            )}
                          </a>
                          <ul style={{ width: '100%' }}>
                            <li style={{ width: '100%', paddingRight: '0px' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <a href={`/user-detail/${jobData?.employer_details?.id}`} >
                                  <h3 style={{ marginBottom: '10px' }}>{jobData?.employer_details?.name || `${jobData?.employer_details?.first_name || ''} ${jobData?.employer_details?.last_name || ''}`.trim()}</h3>
                                </a>
                                <div
                                  className="profile-icon"
                                  onClick={() => handleProfileIconClick({
                                    user_id: jobData?.employer_details?.id,
                                    user_name: jobData?.employer_details?.name || `${jobData?.employer_details?.first_name || ''} ${jobData?.employer_details?.last_name || ''}`.trim(),
                                    profile_image: jobData?.employer_details?.profile_image,
                                    job_location: jobData?.employer_details?.location,
                                    employee_mobile: jobData?.employer_details?.mobile_number,
                                    user_rating: jobData?.employer_details?.ratings?.employer_rating,
                                    no_of_people_reviewed: jobData?.employer_details?.ratings?.rated_by_count
                                  })}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <img src="/assets/images/userProfileInfoIcon.svg" alt="Profile Info" style={{ marginBottom: '0px' }} />
                                </div>
                              </div>
                              <div className="job-title-skills" style={{ justifyContent: 'flex-start' }}>
                                {jobData?.employer_details?.skills && jobData?.employer_details?.skills.split(',').map((skill, index) => (
                                  <span key={index} className="skill-tag">
                                    {skill.trim()}
                                  </span>
                                ))}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="profile-detail yorself">
                      <div className="row">
                        <div className="col-md-1 padding-0">
                          <a href="#!" className="profile-avatar">
                            <img src="/assets/images/term-payment.png" />
                          </a>
                        </div>
                        <div className="col-md-11 padding-0">
                          <ul>
                            <li>
                              <h6> {jobData?.bid_payment_term} </h6>
                              <h2>
                                <img
                                  src="/assets/images/rupee-blue.png"
                                  className="rupee"
                                />{" "}
                                <span>
                                  {" "}
                                  {jobData?.bid_amount} /-
                                </span>
                              </h2>
                              <p> {jobData?.budjet} </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {jobData.job_plan?.is_premium === "0" ? (
                        jobData?.payment_milestone && jobData?.payment_milestone.length > 0 ? jobData?.payment_milestone?.map((value, index) => {
                          const getButtonText = (status) => {
                            switch (status) {
                              case "Start": return "Complete Work";
                              case "Completed": return "Waiting for client confirmation";
                              default:
                                return status;
                            }
                          };
                          const isDisabled = value.employee_milestone_status === "Completed";
                          return (
                            <React.Fragment key={index}>
                              {value.employer_milestone_status !== "Payment Funded" ? (
                                <button
                                  className={`fws-milestone-action-btn ${isDisabled ? 'disabled' : ''}`}
                                  disabled={isDisabled}
                                  style={{width: '100%'}}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (isDisabled) return;
                                    if (value.employee_milestone_status === "Start") {
                                      updateStatus(
                                        jobData?.id,
                                        value.name,
                                        "Completed",
                                        value.amount,
                                        value.milestone_id ? value.milestone_id : null
                                      );
                                    } 
                                  }}
                                >
                                  {getButtonText(value.employee_milestone_status)}
                                </button>
                              ) : <p style={{width: '100%', textAlign: 'center'}}>Job Completed on {jobData.updated_at}</p>}
                            </React.Fragment>
                          );
                        }) : (
                          <div className="fws-no-milestones">
                            <p>No payment milestones available for this job.</p>
                          </div>
                        )
                      ) : (jobData?.payment_milestone && jobData?.payment_milestone.length > 0 ? jobData?.payment_milestone?.map((value, index) => {


                      const getStatusText = (status, milestoneStatus = null) => {
                        switch (status) {
                          case "Start": return milestoneStatus === "Escrow" ?  "Waiting for Escrow to start" : "Escrow Secured, Ready to begin";
                          case "Completed": return "Work In Progress";
                          case "Request To Pay": return milestoneStatus === "Completed" ? "Waiting for client review and confirmation" : "Client confirmed the completion of work";
                          case "Payment Requested": return "Awaiting Fund Release";
                          case "Payment Received": return jobData?.bid_payment_term === "By Completion" ? "Completed and Received Fund" : `${jobData?.bid_payment_term === "By Milestone" ? "Milestone" : "Term"} ${index + 1} Completed and Fund added to wallet`;
                          default: return status;
                        }
                      };

                      const getButtonText = (status) => {
                        switch (status) {
                          case "Start": return "Start Work";
                          case "Completed": return "Mark as Complete";
                          case "Request To Pay": return "Request Fund";
                          case "Payment Requested": return "Request Sent";
                          default: return status;
                        }
                      };

                      const isDisabled = value.employer_milestone_status === "Escrow" || 
                      ( value.employee_milestone_status === "Request To Pay" && value.employer_milestone_status === "Completed") ||
                      (value.employee_milestone_status === "Payment Requested" && value.employer_milestone_status === "Release Fund");
                      
                      const getTermLabel = (paymentTerm, index) => {
                        
                        if (paymentTerm === "By Milestone") {
                          return `Milestone ${index + 1}`;
                        } else if (paymentTerm === "By Completion") {
                          return "By Completion";
                        } else if (paymentTerm === "By Terms" || paymentTerm === "By FWS Term") {
                          return `Term ${String(index + 1).padStart(2, '0')}`;
                        }
                        
                        const normalizedTerm = paymentTerm?.toLowerCase()?.trim();
                        
                        if (normalizedTerm?.includes("milestone")) {
                          return `Milestone ${index + 1}`;
                        } else if (normalizedTerm?.includes("completion")) {
                          return "By Completion";
                        } else if (normalizedTerm?.includes("terms") || normalizedTerm?.includes("fws")) {
                          return `Term ${String(index + 1).padStart(2, '0')}`;
                        } else {
                          return `Term ${String(index + 1).padStart(2, '0')}`;
                        }
                      };

                      const getDescription = (paymentTerm, value) => {
                        if (paymentTerm === "By Milestone") {
                          return value.milestone_descriction || value.name;
                        } else if (paymentTerm === "By Completion") {
                          return value.name || value.milestone_descriction || "Complete Project Delivery";
                        } else if (paymentTerm === "By Terms" || paymentTerm === "By FWS Term") {
                          return (index === 0 ? "Project Initiation & Setup" 
                            : index === 1 ? "Execution & Implementation" 
                            : "Review & Submission")
                        }
                        
                        const normalizedTerm = paymentTerm?.toLowerCase()?.trim();
                        
                        if (normalizedTerm?.includes("milestone")) {
                          return value.milestone_descriction || value.name;
                        } else if (normalizedTerm?.includes("completion")) {
                          return value.name || value.milestone_descriction || "Complete Project Delivery";
                        } else if (normalizedTerm?.includes("terms") || normalizedTerm?.includes("fws")) {
                          return (index === 0 ? "Project Initiation & Setup" 
                            : index === 1 ? "Execution & Implementation" 
                            : "Review & Submission")
                        } else {
                          return value.name || value.milestone_descriction;
                        }
                      };

                      return (
                        <div key={index} className="milestone-card">
                          <div className="milestone-header">
                            <span className="term-number">
                              {getTermLabel(jobData?.bid_payment_term, index)}
                            </span>
                            <span className="amount-percentage">
                              ₹{value.amount} ({Math.round((value.amount / jobData?.bid_amount) * 100)}%)
                            </span>
                          </div>
                          
                          <div className="milestone-description">
                            {getDescription(jobData?.bid_payment_term, value)}
                          </div>
                          
                          <div className="milestone-separator"></div>
                          
                          <div className="milestone-footer">
                            <div className="status-indicator">
                              {value.employee_milestone_status !== "Payment Received" ? <div className={`status-dot`}></div>: <img src={TermFinishedIcon} className="fws-status-img"/>}
                              <span className={`status-text`}>
                                {getStatusText(value.employee_milestone_status, value.employer_milestone_status)}
                              </span>
                            </div>
                            
                            {value.employee_milestone_status !== "Payment Received" && <button
                              className={`milestone-action-btn ${isDisabled ? 'disabled' : 'active'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                if (isDisabled) return;
                                
                                if (value.employee_milestone_status == "Start" || value.employee_milestone_status == "Escrow") {

                                  updateStatus(
                                    jobData?.id,
                                    value.name,
                                    "Completed",
                                    value.milestone_id ? value.milestone_id : null
                                  );
                                } else if (value.employee_milestone_status == "Completed") {
                                  updateStatus(
                                    jobData?.id,
                                    value.name,
                                    "Request To Pay",
                                    value.milestone_id ? value.milestone_id : null
                                  );
                                } else if (value.employee_milestone_status == "Request To Pay") {
                                  updateStatus(
                                    jobData?.id,
                                    value.name,
                                    "Payment Requested",
                                    value.milestone_id ? value.milestone_id : null
                                  );
                                }
                              }}
                            >
                              {getButtonText(value.employee_milestone_status)}
                            </button>
                            }
                          </div>
                        </div>
                      );
                    }) : (
                      <div className="fws-no-milestones">
                        <p>No payment milestones available for this job.</p>
                      </div>
                    )
                      )}
                  </div>
                  <Loader loading={loading} />
                </LoadingOverlay>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={mapView}
        onRequestClose={() => setMapView(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                View Location on Map
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setMapView(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <GoogleMapReact
                  style={{ height: 400 }}
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_LOCATION_API_KEY,
                  }}
                  defaultCenter={{
                    lat: parseFloat(jobData?.latitude),
                    lng: parseFloat(jobData?.longitude),
                  }}
                  defaultZoom={11}
                >
                  <MarkerComponent text="My Marker" />
                </GoogleMapReact>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      
      <ProfilePopup 
        isOpen={showProfilePopup}
        onClose={closeProfilePopup}
        userData={selectedUserData}
      />
    </section>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 1000 },
};
export default connect(mapStateToProps, mapDispatchToProps)(MyJobsDetailView);
